<div class="apply-step col text-center" [ngClass]="status === 'completed'?'apply-step-completed':''">
    <h5>{{stepName}}</h5>
    <img *ngIf="status === 'completed'" class="sub-step-image" src="assets/utils/steps/success-white.png" alt="succes">
    <div *ngIf="status === 'progress'" class="step-progress">{{ 'Global.progress' | translate }}</div>
    <div *ngIf="status === 'not-started'" class="step-not-started">{{ 'Global.not-started' | translate }}</div>
</div>
